import React, { useEffect, useRef, useState } from 'react';
import postscribe from 'postscribe';

const AD_W = 300;
const AD_H = 160;

const AdMaxBanner = () => {
  const containerRef = useRef(null);
  const adRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    if (!containerRef.current) return;
    const update = () => {
      const w = containerRef.current.offsetWidth;
      if (w > 0) setScale(w / AD_W);
    };
    update();
    if (typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(update);
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    if (!adRef.current) return;

    const adTags = [
      `<div style="display:flex;justify-content:center;width:100%;"><script type="text/javascript">rakuten_design="slide";rakuten_affiliateId="52806459.5fb9961a.5280645a.0ab186c8";rakuten_items="ctsmatch";rakuten_genreId="0";rakuten_size="300x160";rakuten_target="_blank";rakuten_theme="gray";rakuten_border="off";rakuten_auto_mode="on";rakuten_genre_title="off";rakuten_recommend="on";rakuten_ts="1775253414041";</script><script type="text/javascript" src="https://xml.affiliate.rakuten.co.jp/widget/js/rakuten_widget.js?20230106"></script></div>`,
      `<div style="display:flex;justify-content:center;width:100%;"><script type="text/javascript">rakuten_design="slide";rakuten_affiliateId="52806459.5fb9961a.5280645a.0ab186c8";rakuten_items="ranking";rakuten_genreId="0";rakuten_size="300x160";rakuten_target="_blank";rakuten_theme="gray";rakuten_border="off";rakuten_auto_mode="on";rakuten_genre_title="off";rakuten_recommend="on";rakuten_ts="1775825952989";</script><script type="text/javascript" src="https://xml.affiliate.rakuten.co.jp/widget/js/rakuten_widget.js?20230106"></script></div>`,
    ];

    const selected = adTags[Math.floor(Math.random() * adTags.length)];
    adRef.current.innerHTML = '';
    postscribe(adRef.current, `
      <div class="ad-wrapper ad-300x160" style="width:${AD_W}px;display:block;line-height:0;margin:0;padding:0;">
        ${selected}
      </div>
    `);
  }, []);

  return (
    <div ref={containerRef} style={{ width: '100%', overflow: 'hidden', height: AD_H * scale + 'px' }}>
      <div
        ref={adRef}
        style={{
          width: AD_W + 'px',
          transformOrigin: 'top left',
          transform: `scale(${scale})`,
        }}
      />
    </div>
  );
};

export default AdMaxBanner;
